module.exports = __webpack_public_path__ + "img/c1.949d4934.png";